import React, { useState } from 'react';
import classnames from 'classnames';
import { ChevronRight } from 'react-feather';

import * as styles from './accordion.module.scss';

export interface AccordionData {
  data: { title: string; rightTitleContent?: Array<string>; children: React.ReactNode }[];
}

const Accordion = ({ data }: AccordionData) => {
  const [expandedBox, setExpandedBox] = useState('');

  const handleExpandClick = (identifier: string) => {
    if (identifier === expandedBox) {
      setExpandedBox('');
    } else {
      setExpandedBox(identifier);
    }
  };
  return (
    <div className={classnames(styles.root)}>
      {data.map(({ title, children, rightTitleContent }, i: number) => {
        const identifier = `${title}-${i}`;
        return (
          <div key={identifier} className={styles.accordionItem}>
            <div
              title={identifier}
              className={classnames(styles.titleBox, 'bg-secondary-a')}
              onClick={() => handleExpandClick(identifier)}
            >
              <h4 className="title brand-a mb-0">
                {title}

                <div className={classnames(styles.chevronWrapper, expandedBox === identifier ? styles.isExpanded : '')}>
                  <ChevronRight size={16} className={styles.chevronIcon} />
                </div>
              </h4>
            </div>
            {Boolean(expandedBox === identifier) && <div className={classnames(styles.content)}>{children}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
